import UiBadge, { type UiBadgeProps } from '@/shared/ui/ui-badge'
import { Tabs, type TabsProps } from 'antd'

type AntdTabItem = NonNullable<TabsProps['items']>[number]

export type UiTabItem = AntdTabItem & {
  /** Số lượng đếm hiển thị trong Badge */
  badgeCount?: number
  /** Màu của Badge (hỗ trợ màu preset antd hoặc CSS token/var) */
  badgeColor?: string
  /** Có hiển thị badge khi số đếm = 0 không (mặc định: true) */
  showBadgeZero?: boolean
  /** Props bổ sung truyền vào UiBadge */
  badgeProps?: Partial<UiBadgeProps>
}

export interface UiTabsProps extends Omit<TabsProps, 'items'> {
  items?: UiTabItem[]
}

export const UiTabs = ({ items, ...rest }: UiTabsProps) => {
  const transformedItems = items?.map((item) => {
    const { badgeCount, badgeColor, showBadgeZero = true, badgeProps, label, ...tabRest } = item

    if (badgeCount === undefined) {
      return { label, ...tabRest }
    }

    const defaultColor =
      badgeColor ?? (badgeCount === 0 ? 'var(--vbdt-color-text-tertiary)' : undefined)

    return {
      ...tabRest,
      label: (
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 'var(--vbdt-space-xs)',
          }}
        >
          <span>{label}</span>
          <UiBadge
            count={badgeCount}
            showZero={showBadgeZero}
            color={defaultColor}
            {...badgeProps}
          />
        </span>
      ),
    }
  })

  return <Tabs items={transformedItems} {...rest} />
}

export default UiTabs
